module.exports = __webpack_public_path__ + "images/bannerFR-e3f31a20142b977a9c0b90366ae0b415.png";